import { render, staticRenderFns } from "./idDetails.vue?vue&type=template&id=ca038a30&scoped=true&"
import script from "./idDetails.vue?vue&type=script&lang=js&"
export * from "./idDetails.vue?vue&type=script&lang=js&"
import style0 from "./idDetails.vue?vue&type=style&index=0&id=ca038a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca038a30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca038a30')) {
      api.createRecord('ca038a30', component.options)
    } else {
      api.reload('ca038a30', component.options)
    }
    module.hot.accept("./idDetails.vue?vue&type=template&id=ca038a30&scoped=true&", function () {
      api.rerender('ca038a30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/email/components/idDetails.vue"
export default component.exports